package com.kitco.metalynxscrapit.shared.di

import io.ktor.client.engine.js.Js
import org.koin.core.module.Module
import org.koin.dsl.module

actual fun platformModule(): Module = module {
    single { Js.create() }
}
